import { makeStyles } from 'makeStyles';
import { LIST_HOVER } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  popoverPaper: {
    border: `solid 1px ${theme.palette.grey['200']}`,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    '& .MuiList-root': {
      padding: '12px 0px',
    },
    '& .MuiListItem-root': {
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: `${LIST_HOVER}`,
      },
    },
  },
  tmxPopover: {
    '& .MuiTypography-body1': {
      fontSize: 15,
    },
  },
}));
